var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-zoom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QBCS---Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QBCS-IM-Homepage-v2-desktop",
    transform: "translate(-426.000000, -1383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHECKS",
    transform: "translate(0.000000, 692.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(154.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_zoom",
    transform: "translate(272.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#393A3D",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(9.000000, 9.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 11,
    x2: 15,
    y2: 15,
    id: "Path-3",
    strokeLinecap: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZoom);
export default __webpack_public_path__ + "static/media/ic-zoom.5baadf620ef50ca58411ceaacaf1b3e0.svg";
export { ForwardRef as ReactComponent };